export default "__VITE_ASSET__DvWvPlfp__"